import { createFileRoute, redirect } from "@tanstack/react-router";
import { toPermissionUser } from "@/lib/permissions";
import { permissionMatrixSearchSchema } from "@/lib/search/permission-matrix-search";
import stores from "@/lib/stores";

const WorkspaceSettingsWorkinghoursRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/workspace/workinghours/")({
	validateSearch: permissionMatrixSearchSchema,
	beforeLoad: ({ search }) => {
		const settings = toPermissionUser(stores.user.useStore.getState().value)?.workspace?.settings;
		if (settings?.projecthoursEnabled === true && settings.workinghoursEnabled !== true) {
			throw redirect({
				replace: true,
				search,
				to: "/settings/workspace/projecthours",
			});
		}
	},
	component: WorkspaceSettingsWorkinghoursRoute,
});
